import { ActionType, getType } from 'typesafe-actions';

import * as buffer from '../../actionCreators/buffer';

const initialState = false;

export default function (
  state: boolean = initialState,
  action: ActionType<typeof buffer>,
): boolean {
  switch (action.type) {
    case getType(buffer.clearBuffer): {
      return initialState;
    }
    case getType(buffer.setBufferReadyToApply): {
      const { value } = action.payload;
      return Boolean(value);
    }
    default:
      return state;
  }
}
